const NUMBERS_MAP = {
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
  FIVE: 5,
  SIX: 6,
  SEVEN: 7,
  EIGHT: 8,
  NINE: 9,
  TEN: 10,
};

export const getNormalCountFromMarketType = (marketType) => {
  if (!marketType) return null;

  const match = marketType.match(
    /^(ONE|TWO|THREE|FOUR|FIVE|SIX|SEVEN|EIGHT|NINE|TEN)_/
  );
  if (match) {
    const fromWords = NUMBERS_MAP[match[1]] ?? null;
    if (fromWords != null) return fromWords;
  }

  const unluckyMatch = marketType.match(/^NOT_(\d+)_SBWBD(?:_BBE)?$/);
  if (unluckyMatch) {
    const parsed = Number(unluckyMatch[1]);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  }

  return null;
};

export const getBonusCountFromMarketType = (marketType) => {
  if (!marketType) return null;
  if (marketType === 'BONUS_BALL') return 1;
  if (marketType.endsWith('_AND_BONUS_BALL')) return 1;
  return 0;
};

export const calculateCombinations = (n, k) => {
  if (k < 0 || n < 0 || k > n) return 0;
  if (k === 0 || k === n) return 1;
  const kk = Math.min(k, n - k);
  let result = 1;
  for (let i = 1; i <= kk; i++) {
    result = (result * (n - kk + i)) / i;
  }
  return result;
};

export const formatCategory = (category) =>
  category
    .replace(/_CATEGORY$/i, '')
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
